<template>
  <DialogTitle
    v-bind="forwardedProps"
    :class="
      cn('tw:text-lg tw:font-semibold tw:leading-none tw:tracking-tight', props.class)
    "
  >
    <slot />
  </DialogTitle>
</template>

<script setup>
import { DialogTitle, useForwardProps } from 'reka-ui'
import { computed } from 'vue'
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
})

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>
